export default {
  id: null,
  company_uuid: null,
  auto_dispatch: true,
  franchise_id: null,
  created_at: null,
  updated_at: null,
  name: null,
  corporate_name: null,
  fancy_name: null,
  business_type: null,
  service_type: null,
  dispatch_type: null,
  cnpj: null,
  cpf: null,
  cpf_validation: null,
  delivery_much_exclusive: true,
  inscricao_estadual: null,
  inscricao_municipal: null,
  tax_regime: null,
  published: false,
  cnae: null,
  legal_nature: null,
  company_size: null,
  inscricao_estadual_status: null,
  activity_start_date: null,
  responsible: {
    name: null,
    cpf: null,
    phone: null,
    email: null,
  },
  responsible_pharmacist: {
    name: null,
    cpf: null,
    crf: null,
    phone: null,
    email: null,
  },
  financial_responsible: {
    name: null,
    phone: null,
    email: null,
  },
  delivery_options: {
    pickup: true,
    delivery: true,
  },
  bank_account: {
    bank_id: null,
    bank_name: null,
    account_number: null,
    account_verification_code: null,
    branch_code: null,
    branch_verification_code: null,
    type: null,
    status: 'NOT_REGISTERED',
    holder: {
      document_type: null,
      document_value: null,
      name: null,
    },
  },
  secondary_bank_account: {
    status: 'NOT_REGISTERED',
  },
  pix: {
    key: null,
    value: null,
  },
  address: {
    zipcode: null,
    state: null,
    state_id: 0,
    city: null,
    city_id: 0,
    neighborhood: null,
    district_id: 0,
    street: null,
    number: null,
    complement: null,
    latitude: null,
    longitude: null,
  },
  cnpj_address: {
    zipcode: null,
    state: null,
    city: null,
    neighborhood: null,
    street: null,
    number: null,
    complement: null,
  },
  tax_exempt: true,
  phone: null,
  attachments: [],
  has_online_payment: true,
  online_payment: {
    fee: 0,
    chargeback_coverage: true,
  },
  delivery_time: null,
  minimum_order_price: 0,
  preparation_time: null,
  description: null,
  timezone: null,
  payment_sections: [
    {
      name: 'Pagamentos - App e Site',
      paymentSections: [
        {
          name: 'Pagamento online - Mundipagg',
          payments: [
            {
              name: 'American Express',
              isActive: true,
            },
            {
              name: 'Aura',
              isActive: true,
            },
            {
              name: 'Diners',
              isActive: true,
            },
            {
              name: 'Discovery',
              isActive: true,
            },
            {
              name: 'Elo',
              isActive: true,
            },
            {
              name: 'Hipercard',
              isActive: true,
            },
            {
              name: 'JCB',
              isActive: true,
            },
            {
              name: 'Mastercard',
              isActive: true,
            },
            {
              name: 'Visa',
              isActive: true,
            },
          ],
        },
      ],
    },
    {
      name: 'Pagamentos - Entrega',
      paymentSections: [
        {
          name: 'Crédito',
          payments: [
            {
              name: 'American Express',
              isActive: true,
            },
            {
              name: 'Amex',
              isActive: false,
            },
            {
              name: 'Aura',
              isActive: true,
            },
            {
              name: 'Diners',
              isActive: true,
            },
            {
              name: 'Discovery',
              isActive: true,
            },
            {
              name: 'Elo',
              isActive: true,
            },
            {
              name: 'Hipercard',
              isActive: true,
            },
            {
              name: 'JCB',
              isActive: true,
            },
            {
              name: 'Mastercard',
              isActive: true,
            },
            {
              name: 'Visa',
              isActive: true,
            },
          ],
        },
        {
          name: 'Débito',
          payments: [
            {
              name: 'American Express',
              isActive: true,
            },
            {
              name: 'Amex',
              isActive: false,
            },
            {
              name: 'Aura',
              isActive: true,
            },
            {
              name: 'Diners',
              isActive: true,
            },
            {
              name: 'Discovery',
              isActive: true,
            },
            {
              name: 'Elo',
              isActive: true,
            },
            {
              name: 'Hipercard',
              isActive: true,
            },
            {
              name: 'JCB',
              isActive: true,
            },
            {
              name: 'Mastercard',
              isActive: true,
            },
            {
              name: 'Visa',
              isActive: true,
            },
          ],
        },
        {
          name: 'Benefício, Alimentação e Refeição',
          payments: [
            {
              name: 'American Express',
              isActive: true,
            },
            {
              name: 'Amex',
              isActive: false,
            },
            {
              name: 'Aura',
              isActive: true,
            },
            {
              name: 'Diners',
              isActive: true,
            },
            {
              name: 'Discovery',
              isActive: true,
            },
            {
              name: 'Elo',
              isActive: true,
            },
            {
              name: 'Hipercard',
              isActive: true,
            },
            {
              name: 'JCB',
              isActive: true,
            },
            {
              name: 'Mastercard',
              isActive: true,
            },
            {
              name: 'Visa',
              isActive: true,
            },
          ],
        },
      ],
    },
  ],
};

export const immutableAfterPublication = [
  'cnpj_address',
  'corporate_name',
  'name',
  'cnpj',
  'responsible',
];
